import { API_CALL } from '../../middleware/api';

export const GET_ACCESS_GCODE_GENERATIONS = 'GET_ACCESS_GCODE_GENERATIONS';
export const GET_ACCESS_GCODE_GENERATIONS_RESULT = `${GET_ACCESS_GCODE_GENERATIONS}/result`;
export const CONFIRM_ACCESS_CARE_DELIVERY = 'CONFIRM_ACCESS_CARE_DELIVERY';
export const CONFIRM_ACCESS_CARE_DELIVERY_RESULT = `${CONFIRM_ACCESS_CARE_DELIVERY}/result`;
export const CREATE_ACCESS_BILLING_DISPOSITION = 'CREATE_ACCESS_BILLING_DISPOSITION';
export const CREATE_ACCESS_BILLING_DISPOSITION_RESULT = `${CREATE_ACCESS_BILLING_DISPOSITION}/result`;
export const GET_ACCESS_BILLING_CLINICIANS = 'GET_ACCESS_BILLING_CLINICIANS';
export const GET_ACCESS_BILLING_CLINICIANS_RESULT = `${GET_ACCESS_BILLING_CLINICIANS}/result`;
export const ASSIGN_ACCESS_BILLING_CLINICIANS = 'ASSIGN_ACCESS_BILLING_CLINICIANS';
export const ASSIGN_ACCESS_BILLING_CLINICIANS_RESULT = `${ASSIGN_ACCESS_BILLING_CLINICIANS}/result`;
export const APPROVE_ACCESS_BILLING_DISPOSITION = 'APPROVE_ACCESS_BILLING_DISPOSITION';
export const APPROVE_ACCESS_BILLING_DISPOSITION_RESULT = `${APPROVE_ACCESS_BILLING_DISPOSITION}/result`;
export const TRANSITION_ACCESS_BILLING_DISPOSITION = 'TRANSITION_ACCESS_BILLING_DISPOSITION';
export const TRANSITION_ACCESS_BILLING_DISPOSITION_RESULT = `${TRANSITION_ACCESS_BILLING_DISPOSITION}/result`;
export const GET_ACCESS_BILLING_DISPOSITION_EVENTS = 'GET_ACCESS_BILLING_DISPOSITION_EVENTS';
export const GET_ACCESS_BILLING_DISPOSITION_EVENTS_RESULT = `${GET_ACCESS_BILLING_DISPOSITION_EVENTS}/result`;

export const actions = {
  getGenerations: () => ({
    [API_CALL]: { method: 'GET', endpoint: 'portal/cmmi-access/gcode-generations' },
    type: GET_ACCESS_GCODE_GENERATIONS,
  }),
  confirmCareDelivery: (generationId, data) => ({
    [API_CALL]: { method: 'POST', endpoint: `portal/cmmi-access/gcode-generations/${generationId}/confirm-care-delivery`, data },
    type: CONFIRM_ACCESS_CARE_DELIVERY,
  }),
  createDisposition: generationId => ({
    [API_CALL]: { method: 'POST', endpoint: `portal/cmmi-access/gcode-generations/${generationId}/billing-dispositions` },
    type: CREATE_ACCESS_BILLING_DISPOSITION,
  }),
  getBillingClinicians: dispositionId => ({
    [API_CALL]: { method: 'GET', endpoint: `portal/cmmi-access/billing-clinicians?disposition_id=${dispositionId}` },
    type: GET_ACCESS_BILLING_CLINICIANS,
  }),
  assignBillingClinicians: (dispositionId, data) => ({
    [API_CALL]: { method: 'PUT', endpoint: `portal/cmmi-access/billing-dispositions/${dispositionId}/clinicians`, data },
    type: ASSIGN_ACCESS_BILLING_CLINICIANS,
  }),
  approveDisposition: dispositionId => ({
    [API_CALL]: { method: 'POST', endpoint: `portal/cmmi-access/billing-dispositions/${dispositionId}/approve` },
    type: APPROVE_ACCESS_BILLING_DISPOSITION,
  }),
  transitionDisposition: (dispositionId, transition, data = {}) => ({
    [API_CALL]: { method: 'POST', endpoint: `portal/cmmi-access/billing-dispositions/${dispositionId}/${transition}`, data },
    type: TRANSITION_ACCESS_BILLING_DISPOSITION,
  }),
  getDispositionEvents: dispositionId => ({
    [API_CALL]: { method: 'GET', endpoint: `portal/cmmi-access/billing-dispositions/${dispositionId}/events` },
    type: GET_ACCESS_BILLING_DISPOSITION_EVENTS,
  }),
};
